const Logo = ({className})=><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" 
	 viewBox="0 0 1184.6 1455.7" className={className} fill="currentColor">
<path className="st0" d="M940.1,1389.6c0,49.1,16.5,65.7,65.9,65.7h112.3c49.4,0,65.9-16.5,65.9-65.7v-197H940.1V1389.6z M627.7,0
	c-255,0-413.9,49.1-523.4,93C19.3,128.6,0,161.7,0,246.7v820.5h244.2V323.4c0-22.1,5.3-38.4,32.8-49.4
	c76.7-24.6,183.5-49.4,317.9-49.4c235.7,0,345.2,109.6,345.2,326.1v516.4h244.2V542.5C1184.3,202.8,1011.5,0,627.7,0z M0,1389.6
	c0,49.1,16.5,65.7,65.9,65.7H181c46.6,0,63.2-16.5,63.2-65.7v-197H0V1389.6z"/>
</svg>
export default Logo;
